import styled from '@emotion/styled';
import MuiGrid from '@mui/material/Grid';

export const LoadingWrapper = styled(MuiGrid)`
  height: 75%;
`;
